import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "legion_token";

window.__LEGION_API__ = API_BASE;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${API_BASE}/api` });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e, fallback = "Something went wrong. Try again.") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${API_BASE}${u}` : u);
